import React, { Component } from 'react';
import GoogleLogin from 'react-google-login';
import PageItem from './PageItem';
import PageItemHeader from './PageItemHeader';
import BlitzAPI from '../../api/BlitzAPI';
import { generateEntrySlug } from '../../utils';

const CLIENT_ID = "141763336902-buo058pgti87glccg7s89h9kmu1qjars.apps.googleusercontent.com";
export default class DashboardHome extends Component {
  constructor(props) {
    super(props);
    this.getData = this.getData.bind(this);
    this.state = {
      output: null,
      pages: [],
    }
  }
  componentDidMount() {
    window.gapi.load('auth2', () => {
      if (!window.gapi.auth2.getAuthInstance()) {
        window.gapi.auth2.init({ client_id: CLIENT_ID }).then(
          () => {
            if (window.gapi.auth2.getAuthInstance().currentUser.get()) {
              this.getData();
            }
        });
      } else {
        if (window.gapi.auth2.getAuthInstance().currentUser.get()) {
          this.getData();
        }
      }
    });
  }
  getData() {
    const getEntries = BlitzAPI.getEntries({ is_blitz: 'true', type: 'article,youtube' }).then((response) => {
      const entries = {}
      const slugs = response.data.data.map(entry => {
        const slug = generateEntrySlug(entry);
        entries[slug] = entry;
        return generateEntrySlug(entry)
      });
      console.log(slugs)
      const getReport = window.gapi.client.request({
        path: '/v4/reports:batchGet',
        root: 'https://analyticsreporting.googleapis.com/',
        method: 'POST',
        body: {
         reportRequests: [
           {
             viewId: '140796225',
             dateRanges: [
               {
                 startDate: '7daysAgo',
                 endDate: 'today'
               }
             ],
             metrics: [
               { expression: 'ga:sessions' },
               { expression: 'ga:avgTimeOnPage' },
               { expression: 'ga:uniquePageviews' },
             ],
             dimensions: [
               { name: 'ga:pagePath' },
              //  { name: 'ga:pageTitle' },
             ],
             dimensionFilterClauses: [
               {
                 filters: [
                   {
                     dimensionName: 'ga:pagePath',
                     operator: 'IN_LIST',
                     expressions: slugs,
                   }
                 ]
               }
             ],
           }
         ]
        }
      }).then((response2) => {
        const pages = response2.result.reports[0].data.rows;
        pages.sort((a, b) => {
          const name_a = a.dimensions[0];
          const name_b = b.dimensions[0];
          return slugs.indexOf(name_a) > slugs.indexOf(name_b) ? 1 : -1;
        });
        this.setState({ pages, entries });
      });
    });
  }
  failure() {

  }

  render() {
    return (
      <div>
        <GoogleLogin
          clientId={CLIENT_ID}
          buttonText="Login"
          onSuccess={this.getData}
          onFailure={this.failure}
        />,
        <PageItemHeader />
        {this.state.pages.map((page, i) => {
          const entry = this.state.entries[page.dimensions[0]];
          return <PageItem key={i} entry={entry} page={page} />;
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/dashboard/DashboardHome.js